module.exports = __webpack_public_path__ + "3f7d755939f891b5e7d4718e19b2960c.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-semibold.eot
// module id = 23
// module chunks = 0